module.exports = __webpack_public_path__ + "static/img/qualifications_icon_02.3a0fd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_02.png
// module id = j5Ts
// module chunks = 3